import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Backdrop, Button, CircularProgress, Container } from "@mui/material";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import GetAuth from "../../../GetAuth";
import { ref, child, get, getDatabase, set } from "firebase/database";

const Details = () => {
	const form = useRef();
	const [info, setInfo] = useState();
	const [submitting, setSubmitting] = useState(false);
	const { register, handleSubmit, reset } = useForm({
		defaultValues: {
			details: "",
			shortDetails: "",
			callNow: "",
		},
	});
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [load, setLoad] = useState();
	useEffect(() => {
		get(child(dbRef, "michelsonaristhyl")).then((snapshot) => {
			setLoad(snapshot.val());
			reset(snapshot.val()?.details);
			setInfo(snapshot.val()?.details);
		});
	}, [dbRef, reset]);

	const onSubmit = ({ details, shortDetails, callNow }) => {
		setSubmitting(true);
		const data = {
			details,
			shortDetails,
			callNow,
			submitTime: new Date().toLocaleString(),
		};
		set(child(dbRef, "michelsonaristhyl"), { ...load, details: data })
			.then(function (response) {
				setSubmitting(false);
				Swal.fire({
					icon: "success",
					title: "Your details updated Successfully",
					showConfirmButton: false,
					timer: 1500,
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	return (
		<Container sx={{ pt: 1 }}>
			<Typography
				variant='h4'
				gutterBottom
				className='textColor'
				sx={{ fontWeight: "bold" }}>
				Details
			</Typography>
			<Typography sx={{ pb: 2 }} className='textColor'>
				Last changed in {info?.submitTime || "N/A"}
			</Typography>

			<form ref={form} onSubmit={handleSubmit(onSubmit)} method='post'>
				<Grid container spacing={3}>
					<Grid item md={12} sm={12} xs={12}>
						<TextField
							required
							name='Details'
							label='Details'
							fullWidth
							multiline
							rows={7}
							InputLabelProps={{
								shrink: true,
							}}
							{...register("details", { required: true })}
						/>
					</Grid>
					<Grid item md={12} sm={12} xs={12}>
						<TextField
							required
							name='Short Details'
							label='Short Details'
							fullWidth
							multiline
							rows={4}
							InputLabelProps={{
								shrink: true,
							}}
							{...register("shortDetails", { required: true })}
						/>
					</Grid>
					<Grid item md={12} sm={12} xs={12}>
						<TextField
							required
							name='Call Now Number'
							label='Call Now Number'
							fullWidth
							InputLabelProps={{
								shrink: true,
							}}
							{...register("callNow", { required: true })}
						/>
					</Grid>

					<Grid item md={12} sm={12} xs={12}>
						<Button
							type='submit'
							variant='contained'
							sx={{
								width: "100%",
								mb: 2,
								px: 3,
								fontWeight: "bold",
								borderRadius: "25px",
							}}>
							Update
						</Button>
					</Grid>
				</Grid>
			</form>
			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={submitting || !info}>
				<CircularProgress color='inherit' />
			</Backdrop>
		</Container>
	);
};

export default Details;
